// PAGE SIZE
export const PAGE_SIZE = 50;
export const LATEST_PAGE_SIZE = 20;
